import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initAnalytics, trackPageView } from '@/lib/analytics';

// Montado no topo do router (dentro do RouterProvider). Inicializa o GA4 uma vez
// e dispara um page_view a CADA navegação do React Router. Renderiza null.
//
// O document.title só atualiza após o efeito de título de cada página; por isso
// usamos um microtask (setTimeout 0) para capturar o título já atualizado.
export function RouteTracker() {
  const location = useLocation();

  useEffect(() => { initAnalytics(); }, []);

  useEffect(() => {
    const path = location.pathname + location.search;
    const id = window.setTimeout(() => trackPageView(path, document.title), 0);
    return () => window.clearTimeout(id);
  }, [location.pathname, location.search]);

  return null;
}
